import React, { Component } from 'react';
import { connect } from 'react-redux'
import AuthActions from '../../store/authRedux'
import LayoutActions from '../../store/layoutRedux'
//import WrappedClientLookup from '../clientLookup/wrappedClientLookup'
//import WrappedDashboard from '../dashboard/wrappedDashboard'
import { push } from 'connected-react-router'
import Loader from '../library/common/Loader';

class LoginCallback extends Component {
    constructor(props) {
    super(props);

        this.state = {
            location: props.location
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.location !== newProps.location) {
            this.setState({ location: newProps.location })
        }       
        if (this.state.selectedButton !== newProps.selectedButton) {
            this.setState({ selectedButton: newProps.selectedButton })
        }

    }

    componentWillMount() {
        this.props.processLoginCallback()     
    }

    render() {
        
        return (
            <Loader />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        location: state.router.location,        
    }
}

const mapDispatchToProps = (dispatch) => ({   
    setPageLoading: (loading) => dispatch(LayoutActions.setPageLoading(loading)),
    processLoginCallback: () => dispatch(AuthActions.processLoginCallback()),    
    setSelectedButton: (buttonTitle) => dispatch(LayoutActions.setSelectedButton(buttonTitle)),
    pushNavigation: (path) => dispatch(push(path))
})


export default connect(mapStateToProps, mapDispatchToProps)(LoginCallback)
